import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { GlobalService } from '../../../helper/Services/global.service';
import { CultureLocaleService } from '../../../Services/culture/culture-locale.service';
import { OrderStatusService } from '../../../Services/orderstatus/order-status.service';
import { AppointmentAdditionalServiceDetails } from './../../../Models/AppointmentAdditionalServiceDetails';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { SecureStorage } from '../../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Features } from '../../../../../../Widget/src/app/business-entities/step.class';
import * as CommonEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { CallDealerLogEntryRequestModel } from '../../../Models/call-dealer-log-entry-requestModel';
import { Application } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import * as saveAs from 'file-saver';

@Component({
  selector: 'app-additional-service-info',
  templateUrl: './additional-service-info.component.html',
  styleUrls: ['./additional-service-info.component.css']
})
export class AdditionalServiceInfoComponent implements OnInit {
  
  currentAppointment: any;
  JobList: any;
  DemandList: any;
  JobDetailList:any;
  Guid:string;
  comments:string=null;
  Allcomments:string=null;
  additionalServiceDetail:AppointmentAdditionalServiceDetails;
  popupCloseResult = false;
  showData: boolean = false;
  buttonJobID: number;
  repairStatusId:number;
  approveAll:boolean=false;
  currentLanguage:string = "";
  features: Features[] = [];
  EnableCookieConsent:boolean = false;
  dealerPhone:string = '';
  @Input() OrderStatusDetail: any;
  @Input() noRecords=false;
  @Input()
  set setAdditionalServiceDetail(value: AppointmentAdditionalServiceDetails) {
    this.additionalServiceDetail = value;
    if(this.additionalServiceDetail?.appointmentAdditionalDemandList?.length > 0)
      {
        let DemandsForApprove =  this.additionalServiceDetail.appointmentAdditionalDemandList.filter(
       x=>x.canBeDoneNow === true && x.isAdminApproved === 0 && x.isCDSSApproved === 0 && x.isMechanicApproved === 0 && x.isCustomerApporved === 0
       );
       if(DemandsForApprove && DemandsForApprove.length > 0 &&
         (this.repairStatusId!== Enums.WOStatus.Invoiceready && this.repairStatusId!==Enums.WOStatus.InvoicePaid && this.repairStatusId!==Enums.WOStatus.Closed)){
         this.approveAll= true;
      }
      else
      {
        this.approveAll=false;
      }
      this.cdr.detectChanges();
   }
  }
  
  constructor(private orderService: OrderStatusService, 
    private gService: GlobalService,
    public cultureLocaleService:CultureLocaleService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    private cookieService: CookieService,
    private secureStorage: SecureStorage,
    private cdr: ChangeDetectorRef,
    ) {
    this.currentAppointment = this.gService.getAppInitialData;
    this.currentLanguage = (this.cookieService.get('userSelectedLanguage'))?.toString();
  }

  ngOnInit(): void {
    this.dealerPhone = this.orderService.dealerPhoneNo;
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features?.length > 0) {
        this.EnableCookieConsent = this.features.find(x => x.featureCode === CommonEnums.FeatureCode.EnableCookieConsent)?.isActive
      }
    }
    if(this.EnableCookieConsent){
      let node = document.createElement('script'); 
      node.src = EnvSetting.Tracker_CookieScript_Key; 
      node.type = 'text/javascript'; 
      document.getElementsByTagName('head')[0].appendChild(node);
     }
    this.Guid = this.currentAppointment.AppointmentGuid;
    this.GetServiceDetails();
  }


  GetServiceDetails(){
    this.orderService.repairActualStatusId.subscribe(resStatusId => {
      this.repairStatusId = resStatusId;
    });
  }

  CallDealerLogEntry(){
    let request:CallDealerLogEntryRequestModel ={
      dealerPhone:this.orderService?.dealerPhoneNo,
    }
    this.orderService.callDealerLogEntry(request).subscribe();
  }
  
  async ApproveAllAdditionalDemand(content, _job:any) {
    this.currentLanguage = (this.cookieService.get('userSelectedLanguage'))?.toString();
    const modalRef = this.modalService.open(content, {
      //windowClass: 'customize-content',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    
    modalRef.result.then((_result) => { 
      //modal result
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if(this.popupCloseResult){
        if(this.additionalServiceDetail.appointmentAdditionalJobList && this.additionalServiceDetail.appointmentAdditionalJobList.length > 0){
          this.spinner.show();
          let DemandsForApprove =  this.additionalServiceDetail.appointmentAdditionalJobList.filter(
            x=>x.canBeDoneNow === true && x.isAdminApproved === 0 && x.isCDSSApproved === 0 && x.isMechanicApproved === 0 && x.isCustomerApporved === 0
            );
          if(DemandsForApprove && DemandsForApprove.length > 0){
            let Demand = []
            DemandsForApprove.forEach((element,index) => {
              let obj ={
                index: index+1,
                jobId:element.id,
                demandId: element.appointmentDemandId,
                sstOperationId: this.additionalServiceDetail.appointmentAdditionalJobList.find(x => x.appointmentDemandId === element.appointmentDemandId).sstOperationId,
              }
              Demand.push(obj);
            });
            let viewModel = {
              isCustomerApproved: 1,
              jobId: Demand,
              comment: this.Allcomments ?? '' ,
              currentLanguage: (this.currentLanguage) ? this.currentLanguage : EnvSetting.LANGUAGE_CONFIG.defaultLanguage,
              BillToCustomerNo: this.OrderStatusDetail.repairStatusDetails.billToCustomerNumber,
              MakeCode: this.OrderStatusDetail.repairStatusDetails.vehicleModel
            }
            this.orderService.ApproveAllAdditionalDemand(viewModel).subscribe(_data => {
              this.approveAll = false
              let msg = this.translate.instant('lblApproved')
              this.toaster.success(msg);
              this.getServices().then(data => {
                this.GetServiceDetails();
              });
              this.Allcomments=null
            },
            (_err)=>{
              this.spinner.hide();
            },
            ()=>{
              this.spinner.hide();
            })

          }
        }
      }
  })}

  async getServices(){
    await this.orderService.GetAdditionalServiceDetail().then(data => {
      if (data.responseObject ?.errorCount > 0) {
        this.additionalServiceDetail = {
          appointmentAdditionalDemandList:[],
          appointmentAdditionalJobList:[],
          appointmentAdditionalJobDetailList:[]
        }
        this.noRecords = true;
      }
      else{
        this.setAdditionalServiceDetail = data.responseObject;         
      }
    });
  }

  async onApprove(content, job:any) {
    this.currentLanguage = (this.cookieService.get('userSelectedLanguage'))?.toString();
    const modalRef = this.modalService.open(content, {
      //windowClass: 'customize-content',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    
    modalRef.result.then((_result) => { 
      //modal result
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if(this.popupCloseResult){
        this.spinner.show();
        let viewModel = {
          isCustomerApproved: 1,
          jobId: this.additionalServiceDetail.appointmentAdditionalJobList.find(x=>x.appointmentDemandId === job.id).id,
          comment: this.comments ?? '' ,
          currentLanguage: (this.currentLanguage) ? this.currentLanguage : EnvSetting.LANGUAGE_CONFIG.defaultLanguage,
          sstOperationId: this.additionalServiceDetail.appointmentAdditionalJobList.find(x => x.appointmentDemandId === job.id).sstOperationId,
          BillToCustomerNo: this.OrderStatusDetail.repairStatusDetails.billToCustomerNumber,
          MakeCode: this.OrderStatusDetail.repairStatusDetails.vehicleModel
        }
        this.orderService.SendCustomerApproval(viewModel).then(_data => {
          this.getServices().then(data => {
            this.GetServiceDetails();
          });
          this.comments=null
        }).finally(()=>{
          this.spinner.hide();
        })
      }
  })}


  ShowButton(job:any)
  {
    this.showData = true;
    this.buttonJobID = job.id;
  }
  
  
  // onApprove(job: any) {
  //   let modelHeadermsg = this.translate.instant("lblConfirmApprove");
  //   let modelBodymsg = this.translate.instant("lblAreYouSureWantToApprove");
  //   const modalRef = this.modalService.open(NgbdModalContent);
  //   modalRef.componentInstance.modelHeader = modelHeadermsg;
  //   modalRef.componentInstance.modelBody = modelBodymsg;
  //   modalRef.result.then((result) => { }, (reason) => {
  //     this.popupCloseResult = this.getDismissReason(reason);
  //     if (this.popupCloseResult) {
  //       let viewModel = {
  //         isCustomerApproved: 1,
  //         jobId: job.id
  //       }
  //       this.orderService.SendCustomerApproval(viewModel).then(data => {
  //         this.GetServiceDetails();
  //       })
  //     }
  //   });
  // }

  // onReject(job: any) {
  //   let modelHeadermsg = this.translate.instant("lblConfimrReject");
  //   let modelBodymsg = this.translate.instant("lblAreYouSureWantToReject");
  //   const modalRef = this.modalService.open(NgbdModalContent);
  //   modalRef.componentInstance.modelHeader = modelHeadermsg;
  //   modalRef.componentInstance.modelBody = modelBodymsg;
  //   modalRef.result.then((result) => { }, (reason) => {
  //     this.popupCloseResult = this.getDismissReason(reason);
  //     if (this.popupCloseResult) {
  //       let viewModel = {
  //         isCustomerApproved: -1,
  //         jobId: job.id
  //       }
  //       this.orderService.SendCustomerApproval(viewModel).then(data => {
  //         this.GetServiceDetails();
  //       })
  //     }
  //   });
  // }
  onReject(content, job:any) {
    this.currentLanguage = (this.cookieService.get('userSelectedLanguage'))?.toString();
    const modalRef = this.modalService.open(content, {
      //windowClass: 'customize-content',
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.result.then((_result) => {
      //modal result
     }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.spinner.show();
        let viewModel = {
          isCustomerApproved: -1,
          jobId: this.additionalServiceDetail.appointmentAdditionalJobList.find(x=>x.appointmentDemandId === job.id).id,
          comment: this.comments ?? '' ,
          currentLanguage: (this.currentLanguage) ? this.currentLanguage : EnvSetting.LANGUAGE_CONFIG.defaultLanguage,
          sstOperationId: this.additionalServiceDetail.appointmentAdditionalJobList.find(x => x.appointmentDemandId === job.id).sstOperationId,
          MakeCode: this.OrderStatusDetail.repairStatusDetails.vehicleModel
        }
        this.orderService.SendCustomerApproval(viewModel).then(_data => {
          this.getServices().then(data => {
            this.GetServiceDetails();
          });
          this.comments=null
        }).finally(()=>{
          this.spinner.hide();
        })
      }
     
  })
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  async downloadFile(path: string) {
    this.spinner.show();
    await this.orderService.DownloadFile(path).then(
      (res: any) => {
        if (res && res.responseCode == 200) {
          const file = res.responseObject;
          const blob = Utility.base64toBlob(file.fileContents, file.contentType);
          saveAs(blob, file.fileDownloadName);
        }
      }).finally(() => {
        this.spinner.hide();
      });
  }
}
